import {html, nothing} from '../lib/lit-html.js';
import {EkmEditProductButton} from '../components/ekmeditproductbutton.js';
import {formatPrice} from '../utils/formatprice.js';

export function searchPageItem(state, item, isSkeleton=false){
	var img = [];
	var price = [];
	var addToCart = [];

	const {showEditButtons, currency} = state;

	if (item.image_url){
		let badges = item.stickers?.join(' ').toLowerCase() || '';

		img = html`
			<div class="ekm-search-page-item-img">
				<a href="${item.url}" data-ekm-badges=${badges || nothing}><img src=${item.image_url} /></a>
			</div>
		`;
	}
	else if (isSkeleton){
		img = html`<div class="ekm-search-page-item-img"></div>`;
	}

	if (item.price !== 0 || isSkeleton){
		price = html`
			<div class="ekm-search-page-item-price">
				${ 
					(!isSkeleton)
						? formatPrice(item.price, currency)
						: nothing
				}
			</div>
		`;
	}

	if (!isSkeleton){
		var id = /\((\d+)\)/.exec(item.id)[1];
		let href = `index.asp?function=CART&mode=ADD&productid=${id}`
		addToCart = html`
			<a class="ekm-search-page-item-atc" href=${href}>Add to Cart</a>
		`
	}

	if (item.short_description){
		item.short_description = item.short_description.replace(/(<([^>]+)>)/ig, "");
	}

	return html`
		<div class="ekm-search-page-item">
			${ img }
			<div class="ekm-search-page-item-info">
				<div class="ekm-search-page-item-name"><a href="${item.url}">${ item.name }</a></div>
				${
					(!isSkeleton && showEditButtons)
						? html`<div class="ekm-search-page-item-editbutton"><ekm-edit-product-button productid=${id}></ekm-edit-product-button></div>`
						: nothing
				}
				${ 
					(item.short_description)
						? html`<div class="ekm-search-page-item-desc">${ item.short_description }</div>`
						: nothing
				}
				${ state.showPrices ? price : nothing }
				${ addToCart }
			</div>
		</div>
	`;
}